<template>
  <div class="risk-calculation-table">
    <LvTwistCircle
      :icon="_resultRisk?_resultRisk.icon:''"
      :color="_resultRisk?_resultRisk.color:''"
      :title="_resultRisk?_resultRisk.title:''"
    />
    <WsFlex
      v-if="showPassRate"
      class="mt-20"
    >
      <WsText001>
        {{ $t('合規率') }}
      </WsText001>
      <WsText001
        class="ml-8"
        bold
      >
        {{ _passRate }}%
      </WsText001>
    </WsFlex>
    <div class="ques-number-list">
      <div
        v-for="(riskQuestionItem, riskQuestionIndex) in _riskQuestionNum"
        :key="riskQuestionIndex"
        class="list-item"
      >
        <WsTextChip001
          has-bg
          :leading-icon="riskQuestionItem.icon"
          :text-label="riskQuestionItem.text"
          icon-xl
          font-size-md
          big
          :red="riskQuestionItem.color==='red'"
          :yellow="riskQuestionItem.color==='yellow'"
          :blue="riskQuestionItem.color==='blue'"
          :green="riskQuestionItem.color==='green'"
        />
        <p class="list-item__number">
          {{ riskQuestionItem.num }}
        </p>
      </div>
    </div>
    <WsEasyTable001
      :dash-include="_dashInclude"
      :result-list="resultList"
      :four-data-num="fourDataNum"
    />
  </div>
</template>
<script>
export default {
  name: "RiskCalculationWithTable",
  props: {
    showPassRate: {
      type: Boolean,
      default: false,
    },
    fourDataNum: {
      type: Boolean,
      default: false,
    },
    noResultText: {
      type: String,
      default() {
        return this.$t("尚無結果");
      },
    },
    majorRiskNum: {
      type: Number,
    },
    minorRiskNum: {
      type: Number,
    },
    ofiRiskNum: {
      type: Number,
    },
    passNum: {
      type: Number,
      default: null,
    },
    unAnswerNum: {
      type: Number,
    },
    quesNum: {
      type: Number,
    },
    majorTag: {
      type: String,
      default: "",
    },
    minorTag: {
      type: String,
      default: "",
    },
    ofiTag: {
      type: String,
      default: "",
    },
    passTag: {
      type: String,
      default: "",
    },
    resultList: {
      type: Array,
      default() {
        return [];
      },
    },
    passRate: {
      type: [String, Number],
    }
  },
  computed: {
    _dashInclude() {
      const array = this._riskQuestionNum.map((element) => {
        return element.num;
      });
      return array;
    },
    _riskQuestionNum() {
      if (this.passNum === 0 || this.passNum > 0) {
        return [
          {
            color: "red",
            icon: "icon-warning-filled",
            text: this.majorTag ? this.majorTag : "Major",
            num: this._majorRisk ? this._majorRisk : 0,
          },
          {
            color: "yellow",
            icon: "icon-warning-filled",
            text: this.minorTag ? this.minorTag : "Minor",
            num: this._minorRisk ? this._minorRisk : 0,
          },
          {
            color: "blue",
            icon: "icon-warning-filled",
            text: this.ofiTag ? this.ofiTag : "OFI",
            num: this._ofiRisk ? this._ofiRisk : 0,
          },
          {
            color: "green",
            icon: "icon-check-circle-filled",
            text: this.passTag ? this.passTag : this.$t("合規"),
            num: this._passNum ? this._passNum : 0,
          },
        ];
      } else
        return [
          {
            color: "red",
            icon: "icon-warning-filled",
            text: this.majorTag ? this.majorTag : "Major",
            num: this._majorRisk ? this._majorRisk : 0,
          },
          {
            color: "yellow",
            icon: "icon-warning-filled",
            text: this.minorTag ? this.minorTag : "Minor",
            num: this._minorRisk ? this._minorRisk : 0,
          },
          {
            color: "blue",
            icon: "icon-warning-filled",
            text: this.ofiTag ? this.ofiTag : "OFI",
            num: this._ofiRisk ? this._ofiRisk : 0,
          },
        ];
    },
    _majorRisk() {
      return this.majorRiskNum;
    },
    _minorRisk() {
      return this.minorRiskNum;
    },
    _ofiRisk() {
      return this.ofiRiskNum;
    },
    _passNum() {
      return this.passNum;
    },
    _resultRisk() {
      const riskLevels = [
        {
          condition: () => this.unAnswerNum >= 1,
          icon: 'icon-help-filled',
          color: 'gray',
          title: '尚無結果'
        },
        {
          condition: () => this._majorRisk >= 1,
          icon: 'icon-risk-high-filled',
          color: 'red',
          title: '高風險'
        },
        {
          condition: () => this._minorRisk >= 1,
          icon: 'icon-risk-medium-filled',
          color: 'yellow',
          title: '中風險'
        },
        {
          condition: () => this._ofiRisk >= 1,
          icon: 'icon-risk-medium-filled',
          color: 'blue',
          title: '低風險'
        },
        {
          condition: () => this._passNum >= 1,
          icon: 'icon-approved-filled',
          color: 'green',
          title: '無異常'
        }
      ];
      const defaultRisk = {
        icon: 'icon-check-circle-filled',
        color: 'gray',
        title: '不涉及風險或不列入統計'
      };
      return riskLevels.find(risk => risk.condition()) || defaultRisk;
    },
    _passRate() {
      if (this.unAnswerNum && this.unAnswerNum >= 1) return '-';
      else if (this.showPassRate && this.passRate !== undefined && this.passRate !== null) return this.passRate;
      else if (this.quesNum) {
        const passRate = (this.passNum / this.quesNum) * 100;
        return passRate.toFixed(2);
      } else return '-';
    },
  },
  methods: {
    $_getPassListByScore(score, list) {
      if (!list || list.length === 0) return;
      const passList = list.filter((item) => item.score === score);
      return passList;
    },
    $_getPassRateByScore(list) {
      if (list.length === 0) return;
      const scoreArray = list.map((item) => item.score);
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      scoreArray.reduce(reducer);
      const result = scoreArray.reduce(reducer) / list.length;
      return result.toFixed(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/risk-calucation-with-table";
</style>